import Swal from "sweetalert2";

export async function sendRequest(url, requestData, method = "POST") {
  let token = document.head.querySelector('meta[name="csrf-token"]')?.content;

  try {
    let response = await fetch(url, {
      method: method,
      headers: {
        "X-CSRF-TOKEN": token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    let data = await response.json();

    if (!response.ok) {
      // if (data.type === "notAuth") {
      //   await Swal.fire({
      //     icon: "error",
      //     text: data.message,
      //     footer: "<a href='/login'>" + data.loginMessage + "</a>",
      //   });
      // } else {
        await Swal.fire({
          icon: "error",
          title: data.title,
          text: data.message,
          footer: data.footer ? `<a href>${data.footer}</a>` : null,
        });
      // }
    } else {
      let cart = document.querySelector('output[name="cartCount"]');
      if (data.cartItemCount !== null && cart) {
        cart.value = data.cartItemCount;
        cart.dispatchEvent(new Event('input'))
      }

      if (data.type === "modal") {
        await Swal.fire({
          title: data.message,
          text: data.body,
          position: "center",
          customClass: {
            popup: "skewed-modal",
            confirmButton: "modal-btn",
            content: "modal-content",
            title: "modal-title",
          },
          background:
            'var(--color-main-active) url("/images/_new-design/modal-back.png")',
          confirmButtonText: '<i class="fas fa-times"></i>',
          confirmButtonColor: "#fff",
          onClose(popup) {
            popup.classList.remove("skewed-modal");
          },
        });
      } else if (data.type === "noNotify") {
        //
      } else {
        await Swal.fire({
          icon: "success",
          title: data.message,
          position: "top-end",
          toast: true,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    }

    return data;
  } catch (e) {
    console.error(e);
    await Swal.fire({
      icon: "error",
      title: "Ошибка!",
      footer: `<a href>Попробуйте перезагрузить страницу</a>`,
    });
  }
}
